import type { TGraphTrajectoryView, TTrajectoryExcludeReason } from '../../../types/graph-trajectory';

export type TChartOverlayRequirements = {
  needsHorizontal: boolean;
  needsVertical: boolean;
};

/**
 * Why a reference trajectory cannot be drawn on a chart with the given overlay needs.
 * Returns null when the series is allowed (or intentional main-only exclusion is handled elsewhere).
 */
export function getReferenceExcludeReasonForChart(
  trajectory: TGraphTrajectoryView,
  requirements: TChartOverlayRequirements,
): TTrajectoryExcludeReason | null {
  if (trajectory.role !== 'reference') {
    return null;
  }

  if (requirements.needsHorizontal) {
    if (trajectory.spatialExcludeReason) {
      return trajectory.spatialExcludeReason;
    }

    if (!trajectory.canPlotSpatial) {
      return 'missingOrigin';
    }
  }

  if (requirements.needsVertical) {
    if (trajectory.verticalExcludeReason) {
      return trajectory.verticalExcludeReason;
    }

    if (!trajectory.canPlotVertical) {
      return 'missingTvdss';
    }
  }

  return null;
}
